import { render } from "./header.vue?vue&type=template&id=45a24c8c&scoped=true"
import script from "./header.vue?vue&type=script&lang=js"
export * from "./header.vue?vue&type=script&lang=js"

import "./header.vue?vue&type=style&index=0&id=45a24c8c&lang=less&scoped=true"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.3.1_@vue+compiler-sfc@3.3.11_vue@3.3.11_webpack@5.89.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45a24c8c"]])

export default __exports__